module.exports = __webpack_public_path__ + "static/media/logo-insta.fdb86d23.svg";